import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageLoader } from "@/components/common/Loading";
import { OwnershipDeck } from "@/components/ownership/OwnershipDeck";

export function deckAction(goTo) {
  return (u) => {
    if (!u) return;
    if (u === "#journey") goTo("journey");
    else if (u === "#schedule") goTo("appointments", "book");
    else if (u === "#requirements") goTo("resources", "knowledge");
    else if (u.startsWith("#task:")) goTo("tasks", null, { taskId: u.slice(6) });
    else if (/^https?:\/\//.test(u)) window.open(u, "_blank", "noopener,noreferrer");
    else if (u.startsWith("/")) window.location.assign(u);
  };
}

export default function PortalOwnership({ goTo }) {
  const [deck, setDeck] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get("/ownership-deck/me").then((r) => setDeck(r.data)).catch(() => setErr(true)); }, []);
  if (err) return <p className="text-slate-500" data-testid="ao-error">The Agency Ownership presentation isn't available right now.</p>;
  if (!deck) return <PageLoader label="Loading presentation" />;
  return <div data-testid="portal-section-ownership"><OwnershipDeck deck={deck} onAction={deckAction(goTo)} /></div>;
}
